import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { ZanattaService } from '../services/zanatta.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuardService implements CanActivate {
  constructor(private zanattaService: ZanattaService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.zanattaService.isAuthAdminAuthorization()) {
      return true;
    } else {
      this.router.navigate(['/info_'], {
        queryParams: { returnUrl: state.url },
      });
      return false;
    }
  }
}
